import { render, staticRenderFns } from "./PublicNavigation.vue?vue&type=template&id=2f910b80&scoped=true"
import script from "./PublicNavigation.vue?vue&type=script&lang=js"
export * from "./PublicNavigation.vue?vue&type=script&lang=js"
import style0 from "./PublicNavigation.vue?vue&type=style&index=0&id=2f910b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f910b80",
  null
  
)

export default component.exports